import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './ATS_CrudOperations.scss';
import { ATS_Backend } from '../../components/TS_AppTools/index.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { LL_H_C, LL_V_L } from '../../components/Layouts/index.js';
import { DropDown_DBModules } from './ui-components.js';
import { TS_DropDown } from '../../components/TS_Dropdown/index.js';
import { SimpleListAdapter } from '../../components/adapter/Adapter.js';
import { TS_TextArea } from '../../components/TS_Input/index.js';
import { Button } from '../../components/Button/Button.js';
import { ModuleFE_Toaster } from '../../component-modules/ModuleFE_Toaster.js';
import { ModuleFE_Thunderstorm } from '../../modules/ModuleFE_Thunderstorm.js';
import { TS_Icons } from '@nu-art/ts-styles';
const ACTIONS = [
    {
        label: 'upsert',
        action: (dbModule, input) => dbModule.v1.upsert(input)
    },
    {
        label: 'upsert all',
        action: (dbModule, input) => dbModule.v1.upsertAll(JSON.parse(input))
    },
    {
        label: 'query',
        action: (dbModule, input) => dbModule.v1.query(input)
    },
    {
        label: 'delete',
        action: (dbModule, input) => dbModule.v1.delete(input)
    },
    {
        label: 'delete query',
        action: (dbModule, input) => dbModule.v1.deleteQuery(input)
    }
];
export class ATS_CrudOperations extends ComponentSync {
    //######################### Life Cycle #########################
    static screen = {
        name: 'Crud Operations',
        key: 'crud-operations',
        renderer: this,
        group: ATS_Backend,
    };
    deriveStateFromProps(nextProps, state) {
        state.input = '{}';
        return state;
    }
    __onSyncStatusChanged(module) {
        this.forceUpdate();
    }
    //######################### Logic #########################
    onDBModuleSelected = (module) => {
        this.setState({ dbModuleToRequest: module, selectedAction: undefined });
    };
    onDBActionSelected = (action) => {
        this.setState({ selectedAction: action });
    };
    onChangeInput = (value) => {
        this.setState({ input: value });
    };
    onClickExecute = async () => {
        const { selectedAction, input, dbModuleToRequest } = this.state;
        if (!dbModuleToRequest || !selectedAction || !input) {
            return ModuleFE_Toaster.toastError('Cannot Execute without all fields');
        }
        try {
            const response = await selectedAction.action(dbModuleToRequest, JSON.parse(input)).executeSync();
            this.setState({ result: response });
        }
        catch (e) {
            this.setState({ result: `error occurred: ${e.message}` });
        }
    };
    //######################### Render #########################
    render() {
        const { dbModuleToRequest, selectedAction, input, result } = this.state;
        return _jsxs(LL_H_C, { className: 'ats-crud-operations-container', children: [_jsxs(LL_V_L, { className: 'ats-crud-operations-container__selection', children: [_jsx(DropDown_DBModules.selectable, { selected: dbModuleToRequest, onSelected: this.onDBModuleSelected }), _jsx(TS_DropDown, { adapter: SimpleListAdapter(ACTIONS, action => _jsx(_Fragment, { children: action.item.label })), selected: selectedAction, placeholder: 'Select Action', onSelected: this.onDBActionSelected }), _jsx(TS_TextArea, { className: 'ats-crud-operations-container__selection__input', type: 'text', placeholder: 'Enter input', disabled: false, value: input, onChange: this.onChangeInput, style: { fontFamily: 'monospace', fontSize: 15 } }, 'crud-operations-query'), _jsxs(LL_H_C, { className: 'ats-crud-operations-container__selection__buttons', children: [_jsx(Button, { className: 'ats-crud-operations-container__selection__execute', disabled: !(dbModuleToRequest && selectedAction && input), onClick: this.onClickExecute, variant: 'primary', children: "Execute" }), _jsx(TS_Icons.copy.component, { onClick: async () => {
                                        if (!result)
                                            return;
                                        const copyObject = JSON.stringify(result, null, 2);
                                        await ModuleFE_Thunderstorm.copyToClipboard(copyObject);
                                    } })] })] }), this.renderResults()] });
    }
    renderResult = (item) => (_jsx(TS_TextArea, { className: 'ats-crud-operations-container__result', type: 'text', value: JSON.stringify(item, null, 2), placeholder: 'Results', disabled: true, style: { fontFamily: 'monospace', fontSize: 15 } }, item?._id));
    renderResults = () => {
        const result = this.state.result;
        if (result && Array.isArray(result)) {
            return (_jsx(LL_V_L, { className: 'ats-crud-operations-container__results', children: result.map((item) => this.renderResult(item)) }));
        }
        return this.renderResult(result);
    };
}
;
//# sourceMappingURL=ATS_CrudOperations.js.map